import Vue from 'vue'
import App from './App.vue'
import store from './store/store'
import Keycloak from "keycloak-js";


Vue.config.productionTip = false

let initOptions = {
  url: 'https://login.dev.zooplus.net/auth', realm: 'zoo-office', clientId: 'sso-customer-historization-ui', onLoad:'login-required'
}

let keycloak = new Keycloak(initOptions);

keycloak.init({ onLoad: initOptions.onLoad }).then((auth) => {

  if(!auth) {
    window.location.reload();
  }

  new Vue({
    store,
    render: h => h(App),
  }).$mount('#app')


  localStorage.setItem("keycloak-token", keycloak.token);
  localStorage.setItem("keycloak-refresh-token", keycloak.refreshToken);

  setInterval(() =>{
    keycloak.updateToken(70).then((refreshed)=>{
      if (refreshed) {
        localStorage.setItem("keycloak-token", keycloak.token);
      }
    }).catch(()=>{
      console.log('Failed to refresh token');
    });


  }, 60000)

}).catch(() =>{
  console.log("Authenticated Failed");
});